import React from "react";
import { cva, VariantProps } from "class-variance-authority";
import { cn } from "@/shared/utils/shadcn";

interface TableRowProps
  extends React.HTMLAttributes<HTMLTableRowElement>,
    VariantProps<typeof tableRowVariants> {}

const tableRowVariants = cva("first:pl-4", {
  variants: {
    variant: {
      header: "bg-gray-100",
      body: "group border-t border-solid border-grey-300",
      ghost: "",
    },
    clickable: {
      true: "hover:bg-grey-100 cursor-pointer",
      false: "",
    },
  },
  defaultVariants: {
    variant: "body",
    clickable: false,
  },
});

const TableRow: React.FC<TableRowProps> = ({
  children,
  className,
  variant,
  onClick,
  ...rest
}) => {
  const classNames = tableRowVariants({ variant, clickable: !!onClick });

  return (
    <tr className={cn(classNames, className)} onClick={onClick} {...rest}>
      {children}
    </tr>
  );
};

export default TableRow;
